import { LocaleIdentifier } from '@repo/markets/types'
import { AlgoliaHit } from './types'

export const algoliaPrimaryIndexName = (locale: LocaleIdentifier): Readonly<string> => {
  return `production-${locale}`
}

export const algoliaProductObjectId = (urlSlug: string): AlgoliaHit['objectID'] => {
  return `product-${urlSlug}`
}
